// extracted by mini-css-extract-plugin
module.exports = {"bottomDarken":"styles_bottomDarken__3dUi5","time":"styles_time__Kgpk6","bottomRight":"styles_bottomRight__1bekd","bottomLeft":"styles_bottomLeft__3Zgl9"};